import { Link, useStaticQuery, graphql } from "gatsby";
import * as React from "react";
import "../styles/nav.scss";
import MenuIcon from "../images/menu.svg";

const NavBar = () => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        footerSettings {
          footerSettings {
            image {
              sourceUrl
              altText
            }
          }
        }
        menu(id: "Navigation Menu", idType: NAME) {
          menuItems(where: { parentId: "" }) {
            nodes {
              id
              url
              label
              childItems {
                nodes {
                  id
                  label
                  url
                }
              }
            }
          }
        }
      }
    }
  `);
  const menuItems = wpdata.wp.menu.menuItems.nodes;
  const logo = wpdata.wp?.footerSettings?.footerSettings?.image;

  return (
    <>
      <nav id="nav" className="justify-between flex bg-black h-32 px-14 w-full">
        <Link className="logo my-auto" to="/">
          <img src={logo?.sourceUrl} alt={logo?.altText} />
        </Link>

        <div className="flex nav-links">
          <ul className="flex text-tan font-anton text-2xl uppercase items-center">
            {menuItems
              .filter((x) => x?.childItems?.nodes?.length > 0)
              .map((item, idx) => {
                const children = item.childItems.nodes;
                const isDropdown = children.length > 0;
                return (
                  <li
                    key={idx}
                    className={isDropdown ? `dropdown-link relative` : ""}
                  >
                    {isDropdown ? (
                      <>
                        {/*eslint-disable-next-line*/}
                        <a href={item.url}>{item.label}</a>
                        <div className="dropdown-container absolute top-0 right-0 min-w-full bg-tan text-black text-right">
                          <ul>
                            {children.map((c, i) => (
                              <li key={i}>
                                <a href={c.url}>{c.label}</a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </>
                    ) : (
                      <a
                        className="text-black bg-tan px-4 py-2"
                        href={item.url}
                      >
                        {item.label}
                      </a>
                    )}
                  </li>
                );
              })}

            <li>
              <div className="spacer"></div>
            </li>

            {menuItems
              .filter((x) => !x?.childItems?.nodes?.length)
              .map((item, idx) => {
                return (
                  <li key={idx}>
                    <a
                      className={
                        item.label.includes("*")
                          ? "text-black bg-tan px-4 py-2"
                          : "flex items-center inline"
                      }
                      href={item.url}
                    >
                      {item.label.replace(/[*]/g, "")}
                    </a>
                  </li>
                );
              })}
          </ul>
          <button
            className="mobile-menu-btn text-tan"
            onClick={() => {
              document.getElementById("nav").classList.add("mobile-open");
            }}
          >
            <MenuIcon />
          </button>
        </div>

        <div
          className="mobile-nav-bg"
          onClick={(e) => {
            document.getElementById("nav").classList.remove("mobile-open");
          }}
        ></div>
        <div className="mobile-nav bg-tan">
          <ul>
            {menuItems.map((item, idx) => {
              const children = item.childItems.nodes;
              const isDropdown = children.length > 0;
              return (
                <li key={idx} className={isDropdown ? `submenu-link` : ""}>
                  {isDropdown ? (
                    <>
                      {/*eslint-disable-next-line*/}
                      <span
                        onClick={(e) => {
                          document
                            .getElementById("nav")
                            .classList.add("submenu-open");
                          e.currentTarget.parentNode
                            .querySelector("ul")
                            .classList.add("active");
                        }}
                      >
                        {item.label}
                      </span>
                      <ul className="submenu">
                        <li>
                          {/*eslint-disable-next-line*/}
                          <span
                            onClick={(e) => {
                              document
                                .getElementById("nav")
                                .classList.remove("submenu-open");
                              e.currentTarget.parentNode.parentElement.classList.remove(
                                "active"
                              );
                            }}
                          >
                            ← Back
                          </span>
                        </li>
                        <li key={"item-" + idx}>
                          <a href={item.url}>{item.label}</a>
                        </li>
                        {children.map((c, i) => (
                          <li key={i}>
                            <a href={c.url}>{c.label}</a>
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <a href={item.url}>{item.label.replace(/[*]/g, "")}</a>
                  )}
                </li>
              );
            })}
          </ul>
          <button
            className="exit-nav text-black"
            onClick={() => {
              document.getElementById("nav").classList.remove("mobile-open");
            }}
          >
            x
          </button>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
